export const LIMIT = { limit: 100, page: 1 };

export const CRON_JOBS_TRACKER_PROPS = {
  COLUMNS: {
    REQUEST_ID: 'Request ID',
    JOB_NAME: 'Job Name',
    STATUS: 'Status',
    START_TIME: 'Start Time',
    END_TIME: 'End Time',
    CREATED_ON: 'Created On',
    UPDATED_ON: 'Updated On',
  },
};
